import APIClient from '@/shared/http/clients/api'

const resourceName = 'tag-quadro-coluna'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (limit, index, filters = {}, config = {}) => {
  let queryParams = `page=${index}&size=${limit}`

  // Só adiciona os parâmetros se tiverem valores numéricos válidos e maiores que 0
  if (filters.boardId != null && filters.boardId !== '' && filters.boardId !== undefined) {
    const boardIdNum = Number(filters.boardId)
    if (!isNaN(boardIdNum) && boardIdNum > 0) {
      queryParams += `&boardId=${boardIdNum}`
    }
  }
  if (filters.boardColumnId != null && filters.boardColumnId !== '' && filters.boardColumnId !== undefined) {
    const boardColumnIdNum = Number(filters.boardColumnId)
    if (!isNaN(boardColumnIdNum) && boardColumnIdNum > 0) {
      queryParams += `&boardColumnId=${boardColumnIdNum}`
    }
  }
  if (filters.tagId != null && filters.tagId !== '' && filters.tagId !== undefined) {
    const tagIdNum = Number(filters.tagId)
    if (!isNaN(tagIdNum) && tagIdNum > 0) {
      queryParams += `&tagId=${tagIdNum}`
    }
  }

  return APIClient.get(`${APICore}/${resourceName}/?${queryParams}`, config)
}

const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)

const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const TagQuadroColunaRepository = {
  GetAllPaging,
  Create,
  Delete
}

export default TagQuadroColunaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/tag-quadro-coluna.js